import { createResourceSelectors } from "src/redux_resources_v1";

export const payerRevisionsResourceSelector = createResourceSelectors(
  "payerRevisions"
);
